// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ds-menubar {
  z-index: 999999999;
}

.ds-menubar svg {
  height: 28px;
}


.ds-desktop {
  background-color: #888;
  background-image: url('/assets/ship-desktop.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 65%;
}


#window-container {
  position: fixed;
  top: 34px;
  left: -2px;
  bottom: 0px;
  right: -2px;

  pointer-events: none;
}

#window-container > * {
  pointer-events: all;
}


.ds-desk-item .desk-icon {
  width: 60px;
  height: 60px;
}

.ds-desk-item .desk-label {
  max-width: 132px;
  text-align: center;
}

.ds-desk-item .desk-label > span {
  padding: 2px 3px;

  background: #fff;
  color: #000;
}


/* op-flex override */
.op-flex {
    --op-flex-gap-vertical: 6px;
    --op-flex-gap-horizontal: 6px;
    --op-flex-split-colour: #000;
    --op-flex-split-width: 2px;
}

/* remove after updating op-flex */
.op-flex.flex-stretch > * {
  flex-basis: 0px;
  flex-grow: 1;
}

.op-flex.flex-stretch:not(.flex-vertical),
.op-flex.flex-stretch:not(.flex-vertical) > * {
  width: 100%;
}

.op-flex .op-flex.flex-stretch:not(.flex-vertical) {
  width: auto;
}

.op-flex.flex-stretch.flex-vertical,
.op-flex.flex-stretch.flex-vertical > * {
  height: 100%;
}

.op-flex .op-flex.flex-stretch.flex-vertical {
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/component/desktop.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,sBAAsB;EACtB,iDAAiD;EACjD,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;AAC3B;;;AAGA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;;EAEX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;;EAEhB,gBAAgB;EAChB,WAAW;AACb;;;AAGA,qBAAqB;AACrB;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".ds-menubar {\n  z-index: 999999999;\n}\n\n.ds-menubar svg {\n  height: 28px;\n}\n\n\n.ds-desktop {\n  background-color: #888;\n  background-image: url('/assets/ship-desktop.png');\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: auto 65%;\n}\n\n\n#window-container {\n  position: fixed;\n  top: 34px;\n  left: -2px;\n  bottom: 0px;\n  right: -2px;\n\n  pointer-events: none;\n}\n\n#window-container > * {\n  pointer-events: all;\n}\n\n\n.ds-desk-item .desk-icon {\n  width: 60px;\n  height: 60px;\n}\n\n.ds-desk-item .desk-label {\n  max-width: 132px;\n  text-align: center;\n}\n\n.ds-desk-item .desk-label > span {\n  padding: 2px 3px;\n\n  background: #fff;\n  color: #000;\n}\n\n\n/* op-flex override */\n.op-flex {\n    --op-flex-gap-vertical: 6px;\n    --op-flex-gap-horizontal: 6px;\n    --op-flex-split-colour: #000;\n    --op-flex-split-width: 2px;\n}\n\n/* remove after updating op-flex */\n.op-flex.flex-stretch > * {\n  flex-basis: 0px;\n  flex-grow: 1;\n}\n\n.op-flex.flex-stretch:not(.flex-vertical),\n.op-flex.flex-stretch:not(.flex-vertical) > * {\n  width: 100%;\n}\n\n.op-flex .op-flex.flex-stretch:not(.flex-vertical) {\n  width: auto;\n}\n\n.op-flex.flex-stretch.flex-vertical,\n.op-flex.flex-stretch.flex-vertical > * {\n  height: 100%;\n}\n\n.op-flex .op-flex.flex-stretch.flex-vertical {\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
